<template>
  <div class="login">
    <div class="bgMp4">
      <img src="/static/picture/jyd_login_bg.png" alt="" width="100%" height="100%" />
    </div>
    <div class="loginWindow">
      <div class="loginTile">
        <div class="logo"><img :src="env.LOGIN_FORM_LOGO" alt="" /></div>
        <div class="name">一个专业级的保函服务管理后台系统</div>
      </div>
      <div class="loginForm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="User Name" prop="userName">
            <el-input class="loginName" placeholder="请输入账号" type="text" v-model="ruleForm.userName" @keyup.native.enter="loginEvent()">
              <template slot="prefix">
                <i class="el-icon-loginyonghu"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="Password" prop="passWord">
            <el-input class="loginPassWord" placeholder="请输入密码" :type="flag ? 'text' : 'password'" v-model="ruleForm.passWord" @keyup.native.enter="loginEvent()">
              <template slot="prefix">
                <i class="el-icon-mima"></i>
              </template>
              <template slot="suffix">
                <i :class="flag ? 'el-icon-loginzhengyan' : 'el-icon-loginbiyan'" @click="flag = !flag"></i>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="loginSubmit" type="primary" @click="loginEvent" :loading="loginLoad"> 登 录 </el-button>
        <div class="version">金源达电子保函工程系统版权所有 V1.1.5</div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  name: 'login',
  mixins: [mixin],
};
</script>
<style scoped lang="less">
@keyframes windowAnimation {
  from {
    top: 60%;
    opacity: 0;
  }
  to {
    top: 50%;
    opacity: 1;
  }
}
.login {
  position: relative;
  .bgMp4 {
    height: 100vh;
    display: flex;
    justify-content: center;
    // background: #222536;
    overflow: hidden;
  }
  .loginWindow {
    width: 454px;
    height: 542px;
    background: #ffffff;
    box-shadow: 0px 3px 12px rgba(37, 38, 44, 0.08);
    border-radius: 20px;
    position: absolute;
    top: 50%;
    left: 160px;
    transform: translateY(-55%);
    padding: 0 40px;
    animation: windowAnimation 1s;
    .loginTile {
      padding-top: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .logo {
        margin-top: 14px;
        width: 105px;
        height: 41px;
        img {
          height: 100%;
        }
      }
      .name {
        font-size: 16px;
        color: #000;
        margin-top: 8px;
      }
    }
    .loginForm {
      margin-top: 32px;
      .el-form-item {
        margin-bottom: 20px;
      }
      .loginName,
      .loginPassWord {
        /deep/ .el-input__inner {
          background: #f7f9fc;
          border-radius: 4px;
          padding: 0 48px;
        }
      }
      .loginSubmit {
        width: 374px;
        background: #eecd22;
        border-color: #eecd22;
        margin-top: 12px;
      }
      .version {
        font-size: 14px;
        font-weight: 400;
        color: #cccccc;
        margin-top: 12px;
        text-align: center;
      }
      .el-icon-loginyonghu,
      .el-icon-mima {
        font-size: 20px;
        margin-left: 8px;
        margin-top: 10px;
      }
      .el-icon-loginzhengyan,
      .el-icon-loginbiyan {
        font-size: 20px;
        color: #eecd22;
        margin-top: 10px;
        margin-right: 8px;
      }
    }
  }
}
</style>
